import {fetchDataFromApi} from './apiHelper';

export const fetchFields = () => fetchDataFromApi('post', '/api/smarthub/bundlesmanager/fields');
export const fetchLists = () => fetchDataFromApi('post', '/api/smarthub/bundlesmanager/lists');